var _style, _path, _g, _polygon, _polygon2, _path2, _polygon3, _polygon4, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHydrophilicFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.hydrophilicFilter-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.hydrophilicFilter-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.hydrophilicFilter-st2{display:none;fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st0",
    d: "M51.4,8.4l14.4,12c0.7,0.8,1.1,3.3,1.1,5.7l0,28.5c0,2.7-0.4,4.9-1.1,5.7L51.4,71.6c-0.2,0.4-0.2,0.3-0.5,0.3 H29.1c-0.2,0-0.3,0-0.5-0.3L14.2,60.3c-0.7-1.1-1.1-3.3-1.1-5.7l0-28.5c0-2.7,0.4-4.9,1.1-5.7l14.3-12c0.2,0,0.3-0.3,0.5-0.3h21.7 C51,8.1,51.2,8.1,51.4,8.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M43,8.6c0,6.4-6,6.4-6,12.8c0,6.4,6,6.4,6,12.8c0,6.4-6,6.4-6,12.8c0,6.4,6,6.4,6,12.8s-6,6.4-6,12.8"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "hydrophilicFilter-st2",
    points: "44.8,2.3 35.2,2.3 35.2,8.1 44.8,8.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "hydrophilicFilter-st2",
    points: "44.8,71.9 35.2,71.9 35.2,77.7 44.8,77.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st0",
    d: "M68.4,38.2H11.5c-0.3,0-0.6,0.3-0.6,0.6v3.5c0,0.3,0.3,0.6,0.6,0.6h56.9c0.3,0,0.6-0.3,0.6-0.6v-3.5 C69,38.5,68.8,38.2,68.4,38.2z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.3,2.3 33.8,8.1 46.2,8.1 44.9,2.3 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "44.6,77.7 46.2,71.9 33.8,71.9 35,77.7 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M-nan-nan"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M-nan-nan"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M-nan-nan"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M-nan-nan"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "hydrophilicFilter-st1",
    d: "M-nan-nan"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrophilicFilter);
export default __webpack_public_path__ + "static/media/hydrophilicFilter.461e110964dbfd45a51ec71b6ef35ff7.svg";
export { ForwardRef as ReactComponent };